import React from "react";

const ImageColumn = ({ image, caption, content, flip, equal, width, rounded }) => {
    const imageUrl = image ? require(`../../assets/projects/${image}`) : undefined;

    let sectionClass = flip ? 'image-column flip' : 'image-column';
    sectionClass = equal ? sectionClass + ' equal' : sectionClass;

    const imgStyle = {
        ...(width && { maxWidth: width }),
        ...(rounded && { borderRadius: 5 })
    };

    return (
        <section className={sectionClass}>
            <div className="container">
                {imageUrl && <div><img src={imageUrl} alt={caption || 'An image'} style={imgStyle} /></div>}
                {(caption || content) && <div>{caption && <h3>{caption}</h3>}{content && <p>{content}</p>}</div>}
            </div>
        </section>
    );
}

export default ImageColumn;